import { MAPBOX_ACCESS_TOKEN } from "@/Shared/Maps/mapboxAccessToken";
import { mapboxStaticStylePath } from "@freightsimple/ui-core/Display/mapboxStyle";
import { MapsMiniMapSkeleton } from "./CustomComponents/MapsMiniMapSkeleton";

interface MiniMapProps {
  latitude: number | undefined;
  longitude: number | undefined;
  city: string | undefined;
  stateOrProvinceCode: string | undefined;
  postalCode: string | undefined;
  width?: number | undefined;
  height?: number | undefined;
  loading?: boolean | undefined;
}

const MiniMap: React.FC<MiniMapProps> = (props: MiniMapProps) => {
  const { latitude, longitude, city, stateOrProvinceCode, postalCode } = props;

  const height = props.height || 156;
  const width = props.width || 349;

  if (!latitude || !longitude || !city || !stateOrProvinceCode || !postalCode) {
    return <></>;
  }

  if (props.loading) {
    return <MapsMiniMapSkeleton width={width} height={height} />;
  }

  function mapPinDescription() {
    return `${props.city},+${props.stateOrProvinceCode},+${props.postalCode}`;
  }

  return (
    <a
      href={`http://maps.apple.com/?ll=${latitude},${longitude}&q=${mapPinDescription()}`}
      target="_new"
    >
      <img
        // Colour in both themes, and so a black pin in both — this thumbnail is
        // read for its streets and landmarks, which the dark style flattens
        // away. See mapboxStaticStylePath.
        src={`https://api.mapbox.com/styles/v1/${mapboxStaticStylePath()}/static/pin-s+000(${longitude},${latitude})/${longitude},${latitude},11/${width}x${height}?access_token=${MAPBOX_ACCESS_TOKEN}`}
        alt="Map"
        data-testid="minimap-image"
      />
    </a>
  );
};
export default MiniMap;
